<div>
    <span class="header" (click)="toggle()">
        <ng-content select="[header]"></ng-content>
        <app-link [iconClass]="isOpen() ? 'dx-icon-chevronup' : 'dx-icon-chevrondown'" [disabled]="disabled()"></app-link>
    </span>

    <div class="content-wrapper" [class.open]="isOpen()" [class.closed]="!isOpen()">
        <div class="content-inner">
            <ng-content></ng-content>
        </div>
    </div>
</div>